import { render } from "./SizeComponent.vue?vue&type=template&id=4f43d388&scoped=true"
import script from "./SizeComponent.vue?vue&type=script&lang=js"
export * from "./SizeComponent.vue?vue&type=script&lang=js"

import "./SizeComponent.vue?vue&type=style&index=0&id=4f43d388&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f43d388"]])

export default __exports__